import { render, staticRenderFns } from "./NavbarSecondary.vue?vue&type=template&id=f517e57e&scoped=true&"
import script from "./NavbarSecondary.vue?vue&type=script&lang=js&"
export * from "./NavbarSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f517e57e",
  null
  
)

export default component.exports